import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { Vraag } from '@models/claims';
import { DataService } from '../../../services/data.service';
import { IBaseVraagboomResultaat, VraagboomAntwoord } from '@models/vragenboom';
import { SharedData } from '@models/shareddata';
import { SharedDataService, WoonglasschadeherstellersService } from '@services/public_api';
import { Hersteller } from '@models/woonglashersteller';
import { takeUntil } from 'rxjs/operators';
import { BaseOlsControlDirective } from '../../base/base-ols-control';

@Component({
  selector: 'app-woonglashersteller',
  templateUrl: './woonglashersteller.component.html',
  styleUrls: ['./woonglashersteller.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class WoonglasherstellerComponent extends BaseOlsControlDirective implements OnInit {
  @Input() vraag: Vraag;
  @Input() inSucces: boolean;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;

  vraagtitel: string;
  postcodeRelatie: string;
  postcodeAanwezig: boolean;
  naam: string;
  telnr: string;
  telnrFormatted: string;
  belangrijk: string[] = [];
  herstellerIsLoaded = false;

  constructor(
    private _dataService: DataService,
    private _sharedDataService: SharedDataService,
    private _woonglasschadeherstellersService: WoonglasschadeherstellersService
  ) { super(); }

  ngOnInit() {
    this.postcodeRelatie = this._dataService.getContact()?.postcode;
    this.vraagtitel = this.vraag.titel;

    if (this.postcodeRelatie?.length >= 4) {
      this.postcodeAanwezig = true;
    } else {
      this.postcodeAanwezig = false;
    }
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.verwerkResultaten(res);
        }
      });
    this._sharedDataService.getTekst('woonglas_belangrijk').pipe(takeUntil(this.unsubscribe$)).subscribe((tekst: string) => {
      this.belangrijk = tekst?.split('|');
    })
  }

  verwerkResultaten(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): void {
    let postcode = 0;
    this.naam = '';
    this.telnr = '';
    this.telnrFormatted = '';

    for (const resultaat of resultaten) {
      for (const antwoord of resultaat.antwoorden) {
        if (antwoord.kenmerken?.length > 1 && ["Inboedelverzekering", "Woonhuisverzekering"].includes(antwoord.kenmerk_titel)) {
          postcode = Number(antwoord.kenmerken[1].substring(0, 4));
        }
      }
    }

    if (postcode === 0 && this.postcodeAanwezig) {
      postcode = Number(this.postcodeRelatie.substring(0, 4));
    }

    // zoek juiste hersteller obv postcode
    if (postcode > 0) {
      this._woonglasschadeherstellersService.getSchadeherstellers().pipe(takeUntil(this.unsubscribe$)).subscribe((herstellers: Hersteller[]) => {
        const hersteller = herstellers.find(h => h.PostcodeRanges && h.PostcodeRanges.findIndex(p => p.PostcodeVanaf <= postcode && p.PostcodeTotEnMet >= postcode) >= 0);
        if (hersteller) {
          this.naam = hersteller.HerstellerNaam;
          this.telnr = hersteller.HerstellerTelefoon;
          this.telnrFormatted = hersteller.HerstellerTelefoonFormatted;
          this.vraagtitel = this.replaceNaam(this.vraagtitel);

          this.herstellerIsLoaded = true;
        }
      });
    }
    else {
      this.herstellerIsLoaded = true;
    }
  }

  replaceNaam(str: string): string {
    if (!str) {
      return '';
    }
    return str.replace('{naam}', this.naam);
  }
}
